/* Test de calce de la ficha de Reckless (snippets/rk-calce.liquid).
 *
 * Tabla de familias: la forma es lectura de las fotos; ancho y alto (cm) salen
 * de "Ancho total" / "Alto del lente" de cada descripción. Los marcados "est"
 * no tienen medidas publicadas y van estimados. Los handles van de más a menos
 * stock (29-sep-2026); el disponible se consulta en vivo en /products/<h>.js,
 * así que un color agotado se salta solo. Un modelo NUEVO no aparece hasta
 * sumarlo aquí. [handle, polarizado 1/0]
 *
 * v = empuje de ventas: 3,5·√(unidades/unidades del Stone), últimos 365 días al
 * 29-sep-2026 (ShopifyQL). Va redondeado y sin unidades: el archivo es público.
 * Inclina las recomendaciones hacia los más vendidos, pero NO entra al
 * veredicto del modelo que se está mirando (ese es sólo calce).
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-rkc]');
  if (!root) return;
  /* A body: un ancestro con transform o filter volvería "relativo" al position:fixed. */
  document.body.appendChild(root);

  var FAM = {
    stone:  { n: 'Stone', v: 3.5, f: 'panto', a: 13.9, h: 5.0,
      hs: [['lentes-de-sol-reckless-stone-shadow',1],['stone-green-matte',1],['stone-caramel',1],['lentes-de-sol-reckless-stone-black-blue',1],['lentes-de-sol-reckless-stone-tortoise',1],['lentes-de-sol-reckless-stone-black-red',1],['stone-black-rose-lentes-de-sol-reckless',1],['lentes-de-sol-reckless-stone-green',1]] },
    wolf:   { n: 'Wolf', v: 3.3, f: 'panto', a: 14.0, h: 5.0,
      hs: [['lentes-de-sol-wolf-shadow',0],['wolf-crystal-clear',0],['wolf-green-matte',0],['lentes-de-sol-reckless-wolf-tortoise-clasico',1],['lentes-de-sol-reckless-wolf-purple',0],['lentes-de-sol-reckless-wolf-tortoise',1],['lentes-de-sol-reckless-wolf-blue',1],['wolf-rose-lentes-de-sol-reckless',1],['lentes-de-sol-reckless-wolf-green',1],['wolf-shadow-gold-lentes-de-sol',1]] },
    cujas:  { n: 'Cujas', v: 1.5, f: 'redondo', a: 13.0, h: 5.0,
      hs: [['lentes-de-sol-reckless-cujas-black-blue',0],['lentes-de-sol-reckless-cujas-shadow',0],['lentes-de-sol-reckless-cujas-tortoise-red',0],['lentes-de-sol-reckless-cujas-black-red',0],['lentes-de-sol-reckless-cujas-green',0],['lentes-de-sol-reckless-cujas-tortoise',0],['lentes-de-sol-reckless-cujas-black-purple',0]] },
    fork:   { n: 'Fork', v: 1.7, f: 'wayfarer', a: 13.9, h: 4.8,
      hs: [['lentes-de-sol-reckless-fork-shadow',1],['fork-black-rose-lentes-de-sol-reckless',1],['lentes-de-sol-reckless-fork-wood-ebano',1],['lentes-de-sol-reckless-fork-tortoise-red',0],['lentes-de-sol-reckless-fork-v2-purple',1],['lentes-de-sol-reckless-fork-faded-black-red',1]] },
    fever:  { n: 'Fever Wood', v: 0.6, f: 'wayfarer', a: 13.9, h: 4.8, est: 1, sib: 'fork',
      hs: [['lentes-de-sol-reckless-fever-wood',1]] },
    rocket: { n: 'Rocket V2', v: 2, f: 'wayfarer', a: 14.5, h: 5.0,
      hs: [['lentes-de-sol-reckless-rocket-v2-shadow',0],['lentes-de-sol-reckless-rocket-v2-black-green',0],['lentes-de-sol-reckless-rocket-blue',0],['lentes-de-sol-reckless-rocket-tortoise',0]] },
    deck:   { n: 'Deck', v: 1, f: 'rect', a: 14.0, h: 4.5, pres: 1,
      hs: [['deck-shadow-lentes-de-sol-reckless',1],['deck-tortoise-lentes-de-sol-reckless',1]] },
    wayne:  { n: 'Wayne', v: 1.3, f: 'cuadrado', a: 13.9, h: 4.6,
      hs: [['lentes-de-sol-wayne-reckless',1]] },
    crank:  { n: 'Crank V2', v: 0.8, f: 'rect', a: 14.1, h: 4.5, dep: 1,
      hs: [['lentes-de-sol-reckless-crank-v2-shadow',0],['lentes-de-sol-reckless-crank-v2-tortoise',0]] },
    parker: { n: 'Parker', v: 0.9, f: 'cuadrado', a: 14.3, h: 4.8, pres: 2,
      hs: [['lentes-de-sol-reckless-parker',1],['parker-sepia',1],['parker-grey-lentes-de-sol-reckless',1],['parker-tortoise-lentes-de-sol-reckless',1]] },
    balino: { n: 'Balino', v: 0.7, f: 'cuadrado', a: 13.9, h: 4.8, pres: 2,
      hs: [['balino-tortoise',1],['balino-lentes-de-sol-reckless',1]] },
    acid:   { n: 'ACID', v: 0.6, f: 'cuadrado', a: 14.0, h: 4.4, pres: 2,
      hs: [['acid-tort-lentes-de-sol-reckless',1],['lentes-de-sol-reckless-acid',1]] },
    george: { n: 'George', v: 0.9, f: 'redondo', a: 14.0, h: 5.0, pres: 2, metal: 1,
      hs: [['george-lentes-de-sol-reckless',0]] },
    kite:   { n: 'Kite', v: 0.4, f: 'aviador', a: 14.5, h: 5.0, pres: 2, metal: 1, est: 1,
      hs: [['kite-lentes-de-sol-reckless',0]] },
    bull:   { n: 'Bull', v: 0.9, f: 'aviador', a: 14.5, h: 5.0, pres: 1, est: 1,
      hs: [['bull-shadow-lentes-de-sol-reckless',1],['bull-orange-translucido-lentes-de-sol-reckless',1]] },
    roke:   { n: 'ROKE', v: 0.2, f: 'cuadrado', a: 14.2, h: 5.2, pres: 2,
      hs: [['lentes-de-sol-reckless-roke-green',0],['lentes-de-sol-reckless-roke-shadow',0],['lentes-de-sol-roke-matte-shadow',0],['lentes-de-sol-reckless-roke-tortoise',1]] },
    mozz:   { n: 'Mozz', v: 0.3, f: 'rect', a: 14.5, h: 4.2, pres: 1,
      hs: [['lentes-de-sol-reckless-mozz',1]] },
    fins:   { n: 'Fins', v: 1, f: 'mascara', a: 14.5, h: 5.0, dep: 1,
      hs: [['fins-lentes-de-sol',0],['fins-blue-lentes-de-sol',1],['lentes-de-sol-reckless-fins-clear-ciclismo',0]] },
    grouch: { n: 'Grouch', v: 0.4, f: 'mascara', a: 14.5, h: 5.5, dep: 1, est: 1,
      hs: [['lentes-de-sol-reckless-grouch-shadow',1]] }
  };

  var FORMA = { panto: 'Panto', redondo: 'Redondo', wayfarer: 'Wayfarer', cuadrado: 'Cuadrado',
                rect: 'Rectangular', aviador: 'Aviador', mascara: 'Máscara deportiva' };

  /* Cuánto favorece cada forma de marco a cada forma de rostro (0 a 3).
     Principio de contraste: rostro curvo, marco anguloso, y al revés. */
  var FIT = {
    ovalado:  { redondo: 2, panto: 3, wayfarer: 3, cuadrado: 3, rect: 2, aviador: 3, mascara: 2 },
    redondo:  { redondo: 0, panto: 1, wayfarer: 3, cuadrado: 3, rect: 3, aviador: 2, mascara: 2 },
    cuadrado: { redondo: 3, panto: 3, wayfarer: 1, cuadrado: 0, rect: 0, aviador: 3, mascara: 1 },
    alargado: { redondo: 1, panto: 2, wayfarer: 3, cuadrado: 3, rect: 1, aviador: 2, mascara: 2 },
    corazon:  { redondo: 3, panto: 3, wayfarer: 2, cuadrado: 1, rect: 1, aviador: 3, mascara: 1 }
  };
  FIT.nose = FIT.ovalado;

  var CARA = { ovalado: 'Rostro ovalado', redondo: 'Rostro redondo', cuadrado: 'Rostro cuadrado',
               alargado: 'Rostro alargado', corazon: 'Rostro corazón', nose: 'Rostro: sin definir' };
  var WHY = {
    ovalado:  '<b>Tu forma es la más versátil:</b> casi todo te queda. La clave es que el marco sea tan ancho como tu cara.',
    redondo:  '<b>Marcos cuadrados, rectangulares o wayfarer.</b> Sus ángulos contrastan las curvas y alargan la cara. Los muy redondos la hacen ver más redonda.',
    cuadrado: '<b>Marcos redondos, panto o aviador.</b> Las curvas suavizan una mandíbula marcada. Los cuadrados endurecen los rasgos.',
    alargado: '<b>Marcos con altura y bien anchos.</b> Cortan visualmente el largo de la cara. Evita los muy angostos.',
    corazon:  '<b>Formas redondeadas, panto o aviador.</b> Equilibran una frente ancha con un mentón más fino.',
    nose:     '<b>Te mostramos las formas más versátiles,</b> las que le quedan bien a casi todos los rostros.'
  };
  /* Pares que se contradicen si se leen por separado: texto propio. */
  var COMBO = {
    'alargado+redondo': '<b>Marcos anchos, con altura y de líneas rectas:</b> wayfarer o cuadrados. Aportan ángulos sin alargar más la cara. Evita los muy redondos y los muy angostos.',
    'alargado+cuadrado': '<b>Marcos con altura y bordes suaves:</b> panto o aviador. Cortan el largo y suavizan la mandíbula.',
    'cuadrado+redondo': '<b>Formas intermedias:</b> wayfarer o panto, ni muy redondas ni muy cuadradas.',
    'alargado+ovalado': '<b>Marcos con altura y bien anchos.</b> Cortan visualmente el largo de la cara. Evita los muy angostos.',
    'corazon+cuadrado': '<b>Panto, redondos o aviador.</b> Las curvas equilibran una frente y una mandíbula anchas.',
    'corazon+redondo': '<b>Wayfarer o panto:</b> algo de ángulo para las mejillas, sin cargar la frente.'
  };
  var TALLA = { chico: 'Calce chico', normal: 'Calce normal', grande: 'Calce grande' };
  var USO = { dia: 'Día a día', polar: 'Polarizados', deporte: 'Deporte', presencia: 'Con presencia' };
  var OBJ = { chico: 13.3, normal: 14.0, grande: 14.5 };

  var KEY = 'rk_calce_v1';
  var st = { faces: [], size: null, uso: null };
  var step = 1;
  var here = famOf(root.getAttribute('data-handle'));
  var trig = document.querySelectorAll('[data-rkc-open]');
  var panel = root.querySelector('.rkc__panel');
  var body = root.querySelector('[data-rkc-body]');
  var bar = root.querySelector('[data-rkc-bar]');
  var back = root.querySelector('[data-rkc-back]');
  var next = root.querySelector('[data-rkc-next]');
  var resBox = root.querySelector('[data-rkc-res]');
  var lastFocus = null, pushed = false;

  function famOf(h) {
    for (var k in FAM) for (var i = 0; i < FAM[k].hs.length; i++) if (FAM[k].hs[i][0] === h) return k;
    return null;
  }
  function track(ev, p) {
    try { if (window.gtag) window.gtag('event', ev, p || {}); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: ev }, p || {})); } catch (e) {}
  }
  function load() {
    try { var s = JSON.parse(localStorage.getItem(KEY) || 'null'); if (s && s.faces && s.size && s.uso) return s; } catch (e) {}
    return null;
  }
  function save() { try { localStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {} }
  function clp(c) { return '$' + Math.round(c / 100).toLocaleString('es-CL'); }
  function cm(n) { return String(n).replace('.', ','); }

  /* ---------- puntaje ---------- */
  function score(k) {
    var F = FAM[k], faces = st.faces.length ? st.faces : ['nose'];
    var fit = 0;
    faces.forEach(function (c) {
      var s = FIT[c][F.f];
      if (c === 'alargado') s += F.h >= 5 ? .5 : (F.h <= 4.5 ? -1 : 0);
      fit += s;
    });
    fit /= faces.length;
    var size = Math.max(0, 3 - Math.abs(F.a - OBJ[st.size || 'normal']) * 3);
    var u = 0, pol = F.hs.some(function (x) { return x[1]; });
    if (st.uso === 'dia') u = (F.dep ? -4 : 0) - (F.pres === 2 ? .4 : 0);
    else if (st.uso === 'polar') u = (pol ? 1.5 : -1.5);
    else if (st.uso === 'deporte') u = F.dep ? 6 : (F.pres || F.metal ? -2 : (F.f === 'wayfarer' || F.f === 'rect' ? 0 : -1));
    else if (st.uso === 'presencia') u = (F.pres ? F.pres * 1.5 : 0) + (F.dep ? -3 : 0);
    var c = fit * 1.6 + size + u;
    /* El empuje de ventas sólo corre si la forma le queda bien (fit >= 2) y no
       le gana al uso deportivo: un más vendido no reemplaza a un deportivo. */
    var v = fit >= 2 && !(st.uso === 'deporte' && !F.dep) ? (F.v || 0) : 0;
    return { t: c + v, c: c, fit: fit, size: size, pol: pol };
  }
  function ranking() {
    return Object.keys(FAM).map(function (k) { var s = score(k); s.k = k; return s; })
      .sort(function (a, b) { return b.t - a.t; });
  }

  /* ---------- productos en vivo ---------- */
  var cache = {};
  function getP(h) {
    if (!cache[h]) {
      var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      cache[h] = fetch(r + 'products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (x) { return x.ok ? x.json() : null; }).catch(function () { return null; });
    }
    return cache[h];
  }
  /* Primer color disponible de la familia; con uso "polar" van primero los polarizados. */
  function pick(k) {
    var hs = FAM[k].hs.slice();
    if (st.uso === 'polar') hs.sort(function (a, b) { return b[1] - a[1]; });
    var i = 0;
    function tryNext() {
      if (i >= hs.length) return Promise.resolve(null);
      var h = hs[i++];
      return getP(h[0]).then(function (p) { return p && p.available ? { p: p, pol: h[1] } : tryNext(); });
    }
    return tryNext();
  }

  /* ---------- pasos ---------- */
  function show(n) {
    step = n;
    root.querySelectorAll('[data-rkc-step]').forEach(function (s) { s.hidden = s.getAttribute('data-rkc-step') !== String(n); });
    back.hidden = n === 1;
    bar.style.width = n === 'res' ? '100%' : (n / 3 * 100 - 12) + '%';
    body.scrollTop = 0;
    if (n === 'res') paint();
  }
  function sync() {
    root.querySelectorAll('[data-rkc-face]').forEach(function (b) {
      b.setAttribute('aria-pressed', st.faces.indexOf(b.getAttribute('data-rkc-face')) > -1 ? 'true' : 'false');
    });
    root.querySelectorAll('[data-rkc-size]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-rkc-size') === st.size ? 'true' : 'false'); });
    root.querySelectorAll('[data-rkc-uso]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-rkc-uso') === st.uso ? 'true' : 'false'); });
    next.disabled = !st.faces.length;
  }

  root.addEventListener('click', function (e) {
    var b = e.target.closest('button, a');
    if (!b || !root.contains(b)) return;
    var face = b.getAttribute('data-rkc-face');
    if (face) {
      var i = st.faces.indexOf(face);
      if (face === 'nose') st.faces = i > -1 ? [] : ['nose'];
      else {
        st.faces = st.faces.filter(function (x) { return x !== 'nose'; });
        if (i > -1) st.faces.splice(st.faces.indexOf(face), 1);
        else { st.faces.push(face); if (st.faces.length > 2) st.faces.shift(); }
      }
      sync(); return;
    }
    if (b.hasAttribute('data-rkc-next')) { show(2); return; }
    if (b.hasAttribute('data-rkc-size')) { st.size = b.getAttribute('data-rkc-size'); sync(); setTimeout(function () { show(3); }, 160); return; }
    if (b.hasAttribute('data-rkc-uso')) {
      st.uso = b.getAttribute('data-rkc-uso'); sync(); save();
      track('calce_quiz_complete', { rostro: st.faces.join('+'), calce: st.size, uso: st.uso, modelo: here || '' });
      setTimeout(function () { show('res'); }, 160); return;
    }
    if (b.hasAttribute('data-rkc-back')) { show(step === 'res' ? 3 : step - 1); return; }
    if (b.hasAttribute('data-rkc-again')) { st = { faces: [], size: null, uso: null }; sync(); show(1); return; }
    if (b.hasAttribute('data-rkc-buyhere')) { close(); var f = document.getElementById('rk2-form'); if (f) f.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    if (b.hasAttribute('data-rkc-card')) track('calce_quiz_click', { modelo: b.getAttribute('data-rkc-card') });
    if (b.hasAttribute('data-rkc-close')) close();
  });
  root.querySelector('.rkc__backdrop').addEventListener('click', close);

  /* ---------- resultado ---------- */
  function verdict(r) {
    if (!here) return null;
    var byFit = r.slice().sort(function (a, b) { return b.c - a.c; });
    var best = byFit[0].c, pos = 0, me = null;
    byFit.forEach(function (x, i) { if (x.k === here) { me = x; pos = i; } });
    var F = FAM[here], why = [];
    if (me.fit < 1.5) why.push('La forma ' + FORMA[F.f].toLowerCase() + ' no es la que más te favorece.');
    if (me.size < 1.2) why.push(F.a > OBJ[st.size] ? 'Puede quedarte algo ancho: mide ' + cm(F.a) + ' cm.' : 'Puede quedarte algo justo: mide ' + cm(F.a) + ' cm.');
    if (st.uso === 'deporte' && !F.dep) why.push('Para deporte hay modelos que se sujetan mejor.');
    var hp = F.hs.filter(function (x) { return x[0] === root.getAttribute('data-handle'); })[0];
    if (st.uso === 'polar' && hp && !hp[1]) why.push('Este color no es polarizado.');
    if (pos < 3 || me.c >= best - 1) return { c: 'ok', i: '✓', t: 'El ' + F.n + ' te queda muy bien', p: 'Es de los modelos que más te favorecen: ' + FORMA[F.f].toLowerCase() + ', ' + cm(F.a) + ' cm de ancho.' + (why.length ? ' ' + why.join(' ') : '') };
    if (me.c >= best - 3.2) return { c: 'mid', i: '~', t: 'El ' + F.n + ' te funciona', p: why.length ? why.join(' ') : 'Te queda bien, aunque hay modelos que te favorecen más.' };
    return { c: 'meh', i: '!', t: 'El ' + F.n + ' no es el que más te favorece', p: (why.join(' ') || 'Hay formas que te van mejor.') + ' Mira estos:' };
  }

  function paint() {
    var r = ranking(), v = verdict(r);
    var faces = st.faces.length ? st.faces : ['nose'];
    var why = COMBO[faces.slice().sort().join('+')] || faces.map(function (c) { return WHY[c]; }).join(' ');
    var html = '<h2 class="rkc__q">Tu calce</h2><div class="rkc-sum">' +
      faces.map(function (c) { return '<span>' + CARA[c] + '</span>'; }).join('') +
      '<span>' + TALLA[st.size] + '</span><span>' + USO[st.uso] + '</span></div>' +
      '<p class="rkc-why">' + why + '</p>';
    if (v) html += '<div class="rkc-here rkc-here--' + v.c + '"><span class="rkc-here__ico" aria-hidden="true">' + v.i + '</span><div><b>' + v.t + '</b><p>' + v.p + '</p>' +
      (v.c !== 'meh' ? '<button type="button" class="rkc-here__buy" data-rkc-buyhere>Seguir con este modelo</button>' : '') + '</div></div>';
    html += '<p class="rkc-h3">' + (v && v.c === 'ok' ? 'También te quedan' : 'Los que mejor te quedan') + '</p><div class="rkc-cards" data-rkc-cards>' +
      '<div class="rkc-card rkc-card--sk"><div class="rkc-card__img"></div><div class="rkc-card__t"><b>Modelo</b><span>Cargando</span></div></div>'.repeat(3) + '</div>' +
      '<p class="rkc-foot">Si no te queda como esperabas, tienes cambio gratis por 30 días.</p>' +
      '<button type="button" class="rkc-again" data-rkc-again>Volver a hacer el test</button>';
    resBox.innerHTML = html;

    var cand = r.filter(function (x) { return x.k !== here; }).slice(0, 8);
    Promise.all(cand.map(function (x) { return pick(x.k); })).then(function (ps) {
      var out = [], box = resBox.querySelector('[data-rkc-cards]');
      if (!box) return;
      /* Variedad: sin gemelos (Fever = Fork en madera) y máximo dos de la misma forma. */
      cand.forEach(function (x, i) {
        if (!ps[i] || out.length >= 3) return;
        var F = FAM[x.k], same = out.filter(function (o) { return FAM[o.k].f === F.f; }).length;
        if (F.sib && (F.sib === here || out.some(function (o) { return o.k === F.sib; }))) return;
        if (x.k === 'fork' && here === 'fever') return;
        if (same >= 2) return;
        out.push({ k: x.k, s: x, r: ps[i] });
      });
      box.innerHTML = out.map(card).join('') || '<p class="rkc-hint">No pudimos cargar los modelos. Revisa la colección de lentes de sol.</p>';
    });
    updTrigger();
  }

  function card(o) {
    var F = FAM[o.k], p = o.r.p, img = p.featured_image || '';
    if (img) img = (img.indexOf('//') === 0 ? 'https:' : '') + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=240';
    var was = p.compare_at_price && p.compare_at_price > p.price ? '<s>' + clp(p.compare_at_price) + '</s>' : '';
    var sub = FORMA[F.f] + ' · ' + cm(F.a) + ' cm' + (o.r.pol ? ' · polarizado' : '');
    var url = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + p.handle;
    return '<a class="rkc-card" href="' + url + '" data-rkc-card="' + o.k + '">' +
      '<span class="rkc-card__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="240" height="180">' : '') + '</span>' +
      '<span class="rkc-card__t"><b>' + p.title.replace(/\s*\+.*$/, '').replace(/^Nuevo\s+/i, '') + '</b><span>' + sub + '</span><em>' + clp(p.price) + '</em>' + was + '</span>' +
      '<span class="rkc-card__go" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 6 6 6-6 6"/></svg></span></a>';
  }

  /* Con el test ya hecho, el botón de la ficha adelanta el veredicto. */
  function updTrigger() {
    if (!st.uso) return;
    var v = verdict(ranking());
    trig.forEach(function (t) {
      var tt = t.querySelector('[data-rkc-tr-t]'), ss = t.querySelector('[data-rkc-tr-s]');
      if (tt) tt.textContent = v ? v.t : 'Tu calce';
      if (ss) ss.textContent = v ? (v.c === 'ok' ? 'Según tu test de calce · ver detalle' : 'Ver los que mejor te quedan') : 'Ver los modelos que mejor te quedan';
      t.setAttribute('data-state', v ? (v.c === 'ok' ? 'ok' : 'meh') : '');
    });
  }

  /* ---------- abrir / cerrar ---------- */
  function open() {
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('rkc-lock');
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    setTimeout(function () { root.classList.add('is-open'); panel.focus({ preventScroll: true }); }, 30);
    sync();
    show(st.uso ? 'res' : 1);
    try { history.pushState({ rkc: 1 }, ''); pushed = true; } catch (e) {}
    track('calce_quiz_open', { modelo: here || '', repetido: st.uso ? 1 : 0 });
  }
  function close(fromPop) {
    if (root.hidden) return;
    panel.style.transform = '';
    root.classList.remove('is-open');
    document.documentElement.classList.remove('rkc-lock');
    setTimeout(function () { if (!root.classList.contains('is-open')) root.hidden = true; }, 320);
    if (pushed && fromPop !== true) { pushed = false; try { history.back(); } catch (e) {} }
    pushed = false;
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  window.addEventListener('popstate', function () { if (!root.hidden) { pushed = false; close(true); } });
  document.addEventListener('keydown', function (e) {
    if (root.hidden) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') {
      var f = panel.querySelectorAll('button:not([disabled]):not([hidden]), a[href]');
      f = Array.prototype.filter.call(f, function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  trig.forEach(function (t) { t.addEventListener('click', open); });

  /* Arrastrar hacia abajo desde el tirador o la cabecera cierra la hoja (móvil). */
  (function () {
    var y0 = null, dy = 0, grab = root.querySelectorAll('.rkc__grip, .rkc__head');
    grab.forEach(function (g) {
      g.addEventListener('touchstart', function (e) { if (e.target.closest('button')) return; y0 = e.touches[0].clientY; dy = 0; panel.style.transition = 'none'; }, { passive: true });
    });
    document.addEventListener('touchmove', function (e) {
      if (y0 === null) return;
      dy = Math.max(0, e.touches[0].clientY - y0);
      panel.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    document.addEventListener('touchend', function () {
      if (y0 === null) return;
      y0 = null; panel.style.transition = '';
      if (dy > 90) close(); else panel.style.transform = '';
    });
  })();

  var saved = load();
  if (saved) { st = saved; updTrigger(); }
})();
